// Standalone so `routeURLs` and the router can use these tabs without importing the page itself,
// which would pull the page and its dependencies into the initial bundle.
export enum CONTACT_DETAILS_TAB_LIST {
  DETAILS = 'details',
  TRIPS = 'trips',
  JET_CARDS = 'jet-cards',
  FLIGHT_CREDITS = 'flight-credits',
  PASSENGERS = 'passengers',
  PETS = 'pets',
  TASKS = 'tasks',
  NOTES = 'notes',
}
